import { render, staticRenderFns } from "./ButtonInput.vue?vue&type=template&id=2a5e5ee4&"
import script from "./ButtonInput.vue?vue&type=script&lang=js&"
export * from "./ButtonInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports